var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _g2, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 908,
    height: 545,
    viewBox: "0 0 908 545",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384.007 393.262C232.755 404.671 95.4354 413.901 95.5636 423.132C95.6918 430.909 193.563 430.653 195.401 448.729C197.153 466.035 108.813 478.77 109.197 499.922C109.582 520.092 190.401 541.971 273.912 544.279C393.367 547.569 406.445 507.657 550.431 493.085C651.166 482.872 680.613 498.811 779.126 476.035C804.855 470.095 909.522 445.865 907.983 423.132C905.889 392.108 706.855 375.314 550.431 380.485C525.728 381.296 542.14 381.339 384.007 393.262Z",
    fill: "#EBECF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.053 466.634C182.921 472.574 146.722 491.419 148.517 503.768C149.842 513.041 172.963 516.503 218.907 524.237C254.509 530.262 276.391 533.938 303.402 533.638C369.689 532.869 439.182 508.383 437.815 494.794C436.832 485.308 397.512 492.871 307.248 475.608C267.288 467.958 248.696 461.463 218.053 466.634Z",
    fill: "#D8D8E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M432.687 450.01C413.156 453.643 408.753 456.292 408.796 458.13C408.924 462.788 438.115 468.77 465.981 462.83C482.093 459.369 494.402 452.66 502.266 447.489C479.016 448.301 455.852 449.156 432.687 450.01Z",
    fill: "#D8D8E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M537.653 422.277C495.855 427.96 491.794 432.362 491.581 435.097C490.47 447.532 564.536 466.847 627.703 473.086C653.176 475.607 717.54 480.009 795.41 459.027C816.01 453.472 862.638 440.908 861.527 431.293C860.501 422.32 818.831 425.824 695.102 418.089C666.852 416.252 610.309 412.363 537.653 422.277Z",
    fill: "#D8D8E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M259.979 81.9541L51.4143 76.5698C32.2246 75.9716 16.5396 63.75 16.5396 48.5372V39.948C16.5396 24.7779 32.2246 13.1973 51.4143 14.0947L259.979 23.8378C276.134 24.6069 289.127 36.3584 289.127 50.1183V57.9384C289.127 71.6983 276.134 82.4669 259.979 81.9541Z",
    fill: "url(#paint0_linear_679_819)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M801.735 307.369L614.112 316.727C600.777 317.411 589.922 307.71 589.922 295.062V287.883C589.922 275.234 600.777 264.636 614.112 264.209L801.735 257.799C813.488 257.414 822.976 266.602 822.976 278.353V285.062C822.976 296.771 813.488 306.77 801.735 307.369Z",
    fill: "url(#paint1_linear_679_819)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M336.012 249.039L33.7208 255.662C15.1722 256.047 0 244.295 0 229.382V220.878C0 205.964 15.1722 193.785 33.7208 193.657L336.012 191.777C351.697 191.691 364.305 202.588 364.305 216.134V223.869C364.305 237.415 351.697 248.697 336.012 249.039Z",
    fill: "url(#paint2_linear_679_819)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M724.934 226.903L633.174 227.801C620.993 227.929 611.035 218.229 611.035 206.135V199.255C611.035 187.162 620.993 177.462 633.174 177.505L724.934 178.06C736.345 178.146 745.534 187.547 745.534 199.127V205.708C745.577 217.331 736.345 226.818 724.934 226.903Z",
    fill: "url(#paint3_linear_679_819)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M748.739 133.318L524.532 128.789C510.941 128.532 499.829 117.935 499.829 105.2V97.9357C499.829 85.1587 510.941 75.2447 524.532 75.7148L748.739 83.7485C760.492 84.1758 769.98 94.0471 769.98 105.799V112.508C769.98 124.259 760.492 133.575 748.739 133.318Z",
    fill: "url(#paint4_linear_679_819)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M590.094 67.425L333.106 57.5538C317.421 56.9555 304.642 45.3322 304.642 31.6578V23.8377C304.642 10.1206 317.464 -0.263472 333.106 0.548448L590.094 14.4793C603.514 15.2057 614.284 25.9744 614.284 38.495V45.6314C614.284 58.1948 603.514 67.9378 590.094 67.425Z",
    fill: "url(#paint5_linear_679_819)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M222.797 163.189L92.8715 161.608C75.5196 161.394 61.2876 149.515 61.2876 135.071V126.866C61.2876 112.423 75.4768 101.141 92.8715 101.611L222.797 105.244C238.867 105.714 251.774 117.166 251.774 130.883V138.703C251.774 152.42 238.867 163.403 222.797 163.189Z",
    fill: "url(#paint6_linear_679_819)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M397.811 79.3043L204.462 72.7662C200.017 72.5953 196.427 75.843 196.427 79.988V411.422C196.427 415.567 200.017 418.687 204.462 418.431L397.811 407.448C401.786 407.235 405.034 403.859 405.034 399.97V86.6116C405.034 82.7229 401.829 79.4325 397.811 79.3043Z",
    fill: "#D8D8E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M318.617 323.436C315.326 285.617 339.986 269.977 330.583 235.706C318.959 193.358 274.254 191.52 258.996 149.941C253.141 134.002 250.833 109.901 267.587 74.9028L204.462 72.7662C200.017 72.5953 196.427 75.843 196.427 79.988V411.422C196.427 415.567 200.017 418.687 204.462 418.431L376.955 408.602C333.148 376.766 320.668 346.682 318.617 323.436Z",
    fill: "#D8D8E8"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M397.811 83.4924L204.461 77.168C202.624 77.1253 201.17 78.45 201.17 80.1166V411.124C201.17 412.833 202.666 414.115 204.461 413.987L397.811 403.218C399.435 403.133 400.76 401.765 400.76 400.141V86.4837C400.803 84.8599 399.478 83.5352 397.811 83.4924Z",
    fill: "url(#paint7_linear_679_819)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M369.134 197.546C369.134 164.685 340.115 137.507 303.659 136.866C266.476 136.225 235.79 163.317 235.79 197.375C235.79 218.058 247.158 236.262 264.467 247.201C271.776 251.816 276.178 259.508 276.178 267.841V272.499C276.178 282.669 284.854 290.66 295.453 290.404L311.822 290.019C322.293 289.763 330.755 281.473 330.755 271.473V266.858C330.755 258.654 335.029 250.962 342.038 246.261C358.492 235.236 369.134 217.502 369.134 197.546Z",
    fill: "#F4F4FA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M318.403 316.813C318.403 320.916 311.821 324.462 303.658 324.761C295.495 325.018 288.828 321.898 288.828 317.753C288.828 313.608 295.495 310.061 303.658 309.805C311.821 309.549 318.403 312.711 318.403 316.813Z",
    fill: "url(#paint8_linear_679_819)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M283.912 304.463V312.155C283.912 314.761 285.451 317.069 287.93 318.137C291.349 319.59 296.99 321.086 305.196 320.616C311.82 320.231 316.137 319.077 318.872 317.881C321.522 316.77 323.189 314.206 323.189 311.471V307.283L283.912 304.463Z",
    fill: "url(#paint9_linear_679_819)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M283.912 311.172C284.51 311.727 285.237 312.155 286.006 312.497C289.853 314.12 314.769 317.24 320.71 314.89C321.479 314.591 322.163 314.206 322.804 313.736C323.061 313.009 323.189 312.24 323.189 311.471V307.283L283.912 304.463V311.172Z",
    fill: "url(#paint10_linear_679_819)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M285.665 299.207C283.443 299.036 281.477 300.745 281.477 302.882V303.095C281.477 306.001 283.229 308.651 286.007 309.804C289.853 311.428 314.77 314.548 320.711 312.24C323.702 311.086 325.54 308.565 325.54 305.488V305.317C325.54 303.48 324.087 301.984 322.207 301.856L285.665 299.207Z",
    fill: "url(#paint11_linear_679_819)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M322.249 301.856L285.665 299.206C284.212 299.121 282.887 299.805 282.118 300.873C282.844 302.497 284.212 303.864 286.007 304.633C289.853 306.257 315.838 309.89 320.711 307.539C322.634 306.642 324.13 305.146 324.899 303.351C324.343 302.497 323.36 301.941 322.249 301.856Z",
    fill: "url(#paint12_linear_679_819)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M284.212 286.814C282.716 286.857 281.477 288.053 281.477 289.463V295.489C281.477 298.394 283.229 301.044 286.007 302.198C289.853 303.821 315.838 307.496 320.711 305.103C323.617 303.693 325.54 301.001 325.54 297.924V288.395C325.54 286.985 324.343 285.831 322.848 285.874L284.212 286.814Z",
    fill: "url(#paint13_linear_679_819)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M325.027 287.711C325.027 290.361 315.497 292.754 303.658 293.053C291.734 293.352 282.032 291.386 282.032 288.694C282.032 286.002 291.734 283.609 303.658 283.353C315.497 283.096 325.027 285.062 325.027 287.711Z",
    fill: "url(#paint14_linear_679_819)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M369.134 197.546C369.134 164.685 340.115 137.507 303.659 136.866C266.476 136.225 235.79 163.317 235.79 197.375C235.79 218.058 247.158 236.262 264.467 247.201C271.776 251.816 276.178 259.508 276.178 267.841V272.499C276.178 282.669 284.854 290.66 295.453 290.404L311.822 290.019C322.293 289.763 330.755 281.473 330.755 271.473V266.858C330.755 258.654 335.029 250.962 342.038 246.261C358.492 235.236 369.134 217.502 369.134 197.546Z",
    fill: "url(#paint15_linear_679_819)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M319.343 284.036C319.343 286.002 312.334 287.754 303.701 287.925C294.982 288.139 287.887 286.686 287.887 284.72C287.887 282.754 294.982 281.002 303.701 280.832C312.334 280.661 319.343 282.114 319.343 284.036Z",
    fill: "#F4F4FA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M299.555 286.644C299.085 286.644 298.7 286.344 298.657 285.917L287.032 199.854C286.947 199.384 287.332 198.956 287.844 198.871C288.357 198.828 288.785 199.127 288.87 199.64L300.452 285.661C300.495 286.131 300.153 286.558 299.683 286.644C299.64 286.644 299.598 286.644 299.555 286.644Z",
    fill: "url(#paint16_linear_679_819)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M306.735 286.515C306.692 286.515 306.649 286.515 306.607 286.515C306.094 286.472 305.752 286.045 305.837 285.575L317.377 199.725C317.419 199.255 317.89 198.913 318.402 198.998C318.915 199.041 319.257 199.511 319.172 199.981L307.675 285.788C307.59 286.173 307.205 286.472 306.735 286.515Z",
    fill: "url(#paint17_linear_679_819)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M316.137 199.811C315.838 199.811 315.539 199.683 315.368 199.426L312.205 194.811C312.163 194.769 312.12 194.726 312.077 194.726C311.992 194.726 311.949 194.769 311.949 194.811L309.855 198.187C309.513 198.743 308.914 199.085 308.231 199.085C307.547 199.085 306.906 198.785 306.564 198.23L303.658 194.085C303.615 194.042 303.572 193.999 303.529 193.999C303.487 193.999 303.444 193.999 303.401 194.042L300.837 197.546C300.452 198.059 299.854 198.358 299.213 198.358C298.572 198.358 297.973 198.059 297.589 197.546L293.913 192.504C293.87 192.461 293.828 192.461 293.785 192.418C293.742 192.418 293.7 192.461 293.657 192.504L290.28 198.016C290.024 198.444 289.468 198.572 289.041 198.315C288.614 198.059 288.443 197.546 288.699 197.119L292.075 191.606C292.417 191.051 293.016 190.709 293.7 190.666C294.383 190.623 295.024 190.965 295.409 191.478L299.085 196.521C299.127 196.563 299.17 196.606 299.213 196.606C299.256 196.606 299.298 196.563 299.341 196.563L301.905 193.059C302.29 192.546 302.888 192.247 303.529 192.247C304.17 192.247 304.769 192.589 305.153 193.102L308.06 197.247C308.102 197.29 308.145 197.332 308.188 197.332C308.273 197.332 308.316 197.29 308.316 197.247L310.41 193.871C310.752 193.316 311.393 192.974 312.034 192.974C312.718 192.974 313.359 193.273 313.701 193.828L316.864 198.444C317.12 198.828 317.035 199.384 316.607 199.64C316.479 199.768 316.308 199.811 316.137 199.811Z",
    fill: "url(#paint18_linear_679_819)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M304.854 245.235C306.265 221.86 346.995 216.262 346.824 195.623C346.738 182.931 330.626 173.359 327.207 171.436C301.563 157.12 269.509 173.145 262.842 161.479C261.175 158.573 261.945 155.411 262.415 153.616C263.099 150.924 264.594 148.403 266.86 146.138C248.226 156.864 235.789 175.709 235.789 197.375C235.789 218.057 247.157 236.261 264.466 247.201C271.775 251.816 276.177 259.508 276.177 267.841V272.499C276.177 282.669 284.853 290.66 295.452 290.404L311.821 290.019C322.292 289.763 330.754 281.472 330.754 271.473V267.798C328.532 269.465 325.967 270.661 323.189 270.704C313.402 270.832 304.17 256.858 304.854 245.235Z",
    fill: "url(#paint19_linear_679_819)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M361.184 199.853C361.184 228.57 336.139 252.201 304.726 252.628C272.8 253.055 246.516 229.424 246.516 199.811C246.516 170.197 272.8 146.566 304.726 147.036C336.139 147.463 361.184 171.137 361.184 199.853Z",
    fill: "#F4F4FA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M361.399 333.393L244.081 337.623C241.303 337.709 239.038 339.931 239.038 342.537C239.038 345.144 241.303 347.195 244.081 347.067L361.399 342.537C364.006 342.452 366.1 340.315 366.1 337.794C366.1 335.23 364.006 333.264 361.399 333.393Z",
    fill: "#D8D8E8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M361.398 349.673L244.08 354.417C241.302 354.545 239.037 356.724 239.037 359.331C239.037 361.938 241.302 363.946 244.08 363.861L361.398 358.818C364.005 358.69 366.099 356.553 366.099 354.032C366.099 351.511 364.005 349.545 361.398 349.673Z",
    fill: "#D8D8E8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M361.398 365.955L244.08 371.211C241.302 371.339 239.037 373.561 239.037 376.168C239.037 378.774 241.302 380.783 244.08 380.655L361.398 375.099C364.005 374.971 366.099 372.835 366.099 370.313C366.099 367.792 364.005 365.826 361.398 365.955Z",
    fill: "#D8D8E8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M300.624 96.5263L241.559 94.8597C240.192 94.817 239.081 95.8425 239.081 97.1245C239.081 98.4065 240.192 99.4748 241.559 99.5175L300.624 101.099C301.949 101.141 303.018 100.116 303.018 98.8766C303.018 97.6373 301.949 96.569 300.624 96.5263Z",
    fill: "#D8D8E8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M300.624 104.731L241.559 103.193C240.191 103.15 239.08 104.176 239.08 105.458C239.08 106.74 240.191 107.808 241.559 107.851L300.624 109.303C301.949 109.346 303.017 108.321 303.017 107.081C303.017 105.799 301.949 104.774 300.624 104.731Z",
    fill: "#D8D8E8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M300.624 112.936L241.559 111.526C240.191 111.483 239.08 112.509 239.08 113.791C239.08 115.073 240.191 116.141 241.559 116.184L300.624 117.508C301.949 117.551 303.017 116.525 303.017 115.243C303.017 114.004 301.949 112.936 300.624 112.936Z",
    fill: "#D8D8E8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M319.087 323.394C315.796 285.575 340.456 269.935 331.054 235.706C319.429 193.358 274.681 191.521 259.466 149.942C253.868 134.644 251.517 111.91 266.091 79.1339L204.974 77.1255C203.137 77.0828 201.684 78.4075 201.684 80.0741V411.038C201.684 412.748 203.179 414.03 204.974 413.901L372.168 404.586C332.549 374.245 321.01 345.7 319.087 323.394Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M755.877 319.163L662.835 322.496C660.655 322.581 658.86 324.504 658.86 326.855C658.86 329.162 660.655 331 662.835 330.914L755.877 327.325C757.929 327.239 759.638 325.359 759.638 323.094C759.638 320.829 757.971 319.077 755.877 319.163Z",
    fill: "#D8D8E8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M755.877 333.692L662.835 337.453C660.655 337.538 658.86 339.504 658.86 341.812C658.86 344.119 660.655 345.914 662.835 345.829L755.877 341.812C757.929 341.726 759.638 339.846 759.638 337.581C759.638 335.359 757.971 333.607 755.877 333.692Z",
    fill: "#D8D8E8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M755.877 348.221L662.835 352.409C660.655 352.495 658.86 354.46 658.86 356.768C658.86 359.075 660.655 360.87 662.835 360.785L755.877 356.383C757.929 356.298 759.638 354.375 759.638 352.153C759.638 349.888 757.971 348.136 755.877 348.221Z",
    fill: "#D8D8E8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M755.877 319.163L662.835 322.496C660.655 322.581 658.86 324.504 658.86 326.855C658.86 329.162 660.655 331 662.835 330.914L755.877 327.325C757.929 327.239 759.638 325.359 759.638 323.094C759.638 320.829 757.971 319.077 755.877 319.163Z",
    fill: "#D8D8E8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M755.877 333.692L662.835 337.453C660.655 337.538 658.86 339.504 658.86 341.812C658.86 344.119 660.655 345.914 662.835 345.829L755.877 341.812C757.929 341.726 759.638 339.846 759.638 337.581C759.638 335.359 757.971 333.607 755.877 333.692Z",
    fill: "#D8D8E8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M755.877 348.221L662.835 352.409C660.655 352.495 658.86 354.46 658.86 356.768C658.86 359.075 660.655 360.87 662.835 360.785L755.877 356.383C757.929 356.298 759.638 354.375 759.638 352.153C759.638 349.888 757.971 348.136 755.877 348.221Z",
    fill: "#D8D8E8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M755.877 289.848L662.835 292.37C660.655 292.412 658.86 294.378 658.86 296.686C658.86 298.993 660.655 300.831 662.835 300.788L755.877 298.053C757.929 298.01 759.638 296.13 759.638 293.865C759.638 291.558 757.971 289.806 755.877 289.848Z",
    fill: "#D8D8E8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M755.877 304.377L662.835 307.326C660.655 307.411 658.86 309.334 658.86 311.642C658.86 313.95 660.655 315.787 662.835 315.702L755.877 312.539C757.929 312.454 759.638 310.574 759.638 308.352C759.638 306.087 757.971 304.292 755.877 304.377Z",
    fill: "#D8D8E8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M143.174 304.078C149.67 307.283 156.252 310.274 162.876 313.009C169.501 315.744 176.168 318.222 182.878 320.487C196.298 324.931 209.932 328.265 223.565 330.145C237.199 332.025 250.875 332.495 264.253 331.299C270.963 330.7 277.63 329.675 284.169 328.265L286.605 327.709C287.417 327.495 288.229 327.367 289.041 327.111C290.665 326.683 292.289 326.256 293.913 325.786L296.307 325.06L297.503 324.718L298.7 324.333L301.093 323.564C301.863 323.308 302.675 323.008 303.444 322.709C315.966 318.222 327.634 311.983 338.49 303.992C349.388 296.044 359.474 286.301 369.39 275.362C374.347 269.892 379.305 264.123 384.391 258.183C389.477 252.243 394.691 246.09 400.247 239.936C405.803 233.783 411.701 227.629 418.112 221.647C421.317 218.655 424.694 215.75 428.198 212.972C431.703 210.152 435.378 207.459 439.182 204.938C442.986 202.417 446.96 200.024 451.021 197.802C455.124 195.622 459.312 193.657 463.586 191.862C467.86 190.11 472.219 188.572 476.621 187.247C481.023 185.922 485.468 184.854 489.913 183.956C498.802 182.247 507.949 181.179 517.137 181.179C519.445 181.136 521.71 181.222 524.018 181.307C526.283 181.435 528.591 181.563 530.856 181.82C533.122 181.991 535.387 182.333 537.652 182.632C539.874 182.974 542.139 183.315 544.319 183.786C548.764 184.64 553.123 185.666 557.354 186.862C561.628 188.059 565.817 189.384 569.877 190.879C573.937 192.375 577.912 193.956 581.801 195.622C585.69 197.289 589.494 199.041 593.212 200.836C608.085 208.015 621.804 215.878 635.267 222.715C648.687 229.595 661.936 235.492 675.356 238.953C678.69 239.851 682.066 240.534 685.442 241.133C688.819 241.731 692.195 242.073 695.571 242.329L698.136 242.5L700.7 242.586C701.555 242.628 702.41 242.628 703.264 242.586C704.119 242.586 704.974 242.586 705.829 242.543L708.393 242.457C709.248 242.415 710.102 242.329 710.957 242.286C712.667 242.201 714.376 241.945 716.086 241.774C722.881 240.876 729.72 239.381 736.43 237.287C743.139 235.236 749.636 232.501 756.004 229.339C762.329 226.134 768.526 222.501 774.424 218.314C780.365 214.168 786.049 209.596 791.52 204.725L791.605 204.682C797.076 199.81 805.453 200.28 810.325 205.707C815.069 211.006 814.727 219.083 809.726 223.997C803.786 229.809 797.46 235.364 790.75 240.492C784.083 245.662 776.946 250.32 769.467 254.508C761.987 258.696 754.123 262.328 746.003 265.277C737.84 268.225 729.42 270.49 720.744 272.028C718.565 272.37 716.385 272.755 714.205 272.969C713.094 273.097 712.026 273.268 710.915 273.353L707.624 273.652C706.512 273.738 705.401 273.78 704.29 273.866C703.179 273.909 702.068 273.994 700.956 273.994L697.623 274.037L694.289 273.994C689.844 273.866 685.4 273.567 681.04 273.011C676.681 272.456 672.321 271.729 668.048 270.832C663.774 269.892 659.585 268.823 655.44 267.627C651.294 266.388 647.277 265.063 643.302 263.61C635.353 260.704 627.702 257.457 620.351 254.081C605.564 247.329 591.716 240.193 578.083 234.381C564.492 228.527 551.115 224.04 537.908 222.159C536.242 221.903 534.617 221.732 532.993 221.561C531.369 221.433 529.702 221.262 528.078 221.219C526.454 221.091 524.788 221.134 523.163 221.091C521.539 221.134 519.915 221.134 518.291 221.219C511.795 221.518 505.341 222.544 498.888 224.082C495.683 224.894 492.563 225.792 489.485 226.86C486.451 227.928 483.459 229.125 480.553 230.492C477.647 231.86 474.826 233.355 472.048 234.979C469.313 236.603 466.62 238.441 463.97 240.364C461.321 242.286 458.799 244.338 456.277 246.56C453.756 248.782 451.277 251.089 448.884 253.525C444.011 258.439 439.31 263.781 434.609 269.507C425.206 280.917 415.889 293.608 405.29 306.343C402.64 309.505 399.905 312.71 397.084 315.872C394.264 319.034 391.357 322.197 388.323 325.273C386.827 326.812 385.246 328.35 383.707 329.888C382.126 331.384 380.544 332.922 378.92 334.375C377.296 335.871 375.63 337.324 373.963 338.777C372.253 340.187 370.586 341.64 368.834 343.05C367.125 344.46 365.33 345.828 363.534 347.195L360.799 349.204L359.432 350.186L358.021 351.169C354.346 353.776 350.499 356.169 346.61 358.519L343.661 360.229C342.678 360.784 341.695 361.34 340.669 361.895C338.703 363.006 336.652 364.032 334.643 365.057C330.583 367.066 326.48 368.946 322.292 370.655C321.266 371.083 320.197 371.51 319.172 371.937L316.009 373.134L314.428 373.732L312.846 374.288L309.684 375.399C307.547 376.082 305.41 376.766 303.273 377.45C302.204 377.792 301.136 378.091 300.025 378.39L296.777 379.287C288.101 381.595 279.297 383.347 270.45 384.543C252.713 386.936 234.848 387.107 217.368 385.441C199.845 383.817 182.75 380.398 166.21 375.74C157.919 373.39 149.798 370.741 141.806 367.878C133.814 364.972 125.95 361.81 118.257 358.434C103.128 351.853 96.204 334.29 102.786 319.163C109.368 304.035 126.933 297.112 142.063 303.693C142.319 303.693 142.789 303.907 143.174 304.078Z",
    fill: "url(#paint20_linear_679_819)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M832.463 227.159C830.198 204.212 809.726 187.46 786.775 189.768C782.544 190.195 781.048 184.255 785.023 182.674L849.943 156.095C851.653 155.411 853.448 156.864 853.063 158.659L839.771 227.544C838.959 231.689 832.891 231.39 832.463 227.159Z",
    fill: "url(#paint21_linear_679_819)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M601.932 86.2272L430.293 80.4155C426.361 80.2873 423.199 83.3214 423.199 87.21V398.945C423.199 402.833 426.404 405.782 430.293 405.568L601.932 395.825C605.479 395.611 608.343 392.492 608.343 388.774V93.1071C608.343 89.3894 605.479 86.3126 601.932 86.2272Z",
    fill: "#D8D8E8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M531.498 316.43C528.592 280.791 550.474 266.09 542.14 233.785C531.797 193.872 492.093 192.163 478.588 153.02C473.416 138.021 471.365 115.33 486.195 82.3402L430.293 80.46C426.361 80.3318 423.198 83.3658 423.198 87.2545V398.989C423.198 402.878 426.404 405.826 430.293 405.613L583.34 396.895C544.405 366.726 533.293 338.309 531.498 316.43Z",
    fill: "#D8D8E8"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M601.931 90.1586L430.292 84.5606C428.668 84.5179 427.386 85.7572 427.386 87.3383V398.731C427.386 400.312 428.711 401.551 430.292 401.466L601.931 391.894C603.384 391.808 604.58 390.526 604.58 388.988V92.979C604.58 91.4406 603.384 90.2014 601.931 90.1586Z",
    fill: "url(#paint22_linear_679_819)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M569.494 325.872L465.339 329.632C462.861 329.718 460.895 331.769 460.895 334.248C460.895 336.683 462.903 338.606 465.339 338.521L569.494 334.504C571.801 334.418 573.682 332.41 573.682 330.017C573.682 327.667 571.844 325.786 569.494 325.872Z",
    fill: "#D8D8E8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M569.493 341.213L465.338 345.444C462.86 345.529 460.894 347.623 460.894 350.059C460.894 352.495 462.902 354.418 465.338 354.332L569.493 349.845C571.8 349.76 573.681 347.751 573.681 345.358C573.681 343.008 571.843 341.128 569.493 341.213Z",
    fill: "#D8D8E8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M569.493 356.597L465.338 361.297C462.86 361.425 460.894 363.476 460.894 365.955C460.894 368.391 462.902 370.314 465.338 370.185L569.493 365.229C571.8 365.1 573.681 363.092 573.681 360.742C573.681 358.349 571.843 356.468 569.493 356.597Z",
    fill: "#D8D8E8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M515.515 102.594L463.117 101.098C461.92 101.055 460.895 102.038 460.895 103.235C460.895 104.431 461.878 105.457 463.117 105.499L515.515 106.91C516.711 106.952 517.651 106.012 517.651 104.816C517.651 103.619 516.668 102.636 515.515 102.594Z",
    fill: "#D8D8E8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M515.514 110.328L463.116 108.961C461.919 108.918 460.894 109.901 460.894 111.097C460.894 112.294 461.877 113.32 463.116 113.362L515.514 114.644C516.71 114.687 517.65 113.747 517.65 112.55C517.65 111.354 516.668 110.371 515.514 110.328Z",
    fill: "#D8D8E8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M515.514 118.063L463.116 116.824C461.919 116.781 460.894 117.764 460.894 118.96C460.894 120.157 461.877 121.182 463.116 121.225L515.514 122.422C516.71 122.464 517.65 121.481 517.65 120.285C517.65 119.088 516.668 118.063 515.514 118.063Z",
    fill: "#D8D8E8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M495.298 200.963C498.717 194.51 505.085 189.938 512.522 189.126L513.035 157.333C491.794 157.889 473.459 171.007 465.253 189.767L495.298 200.963Z",
    fill: "url(#paint23_linear_679_819)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M537.01 215.449C535.215 226.004 526.112 234.123 515.171 234.209C511.922 234.252 508.845 233.568 506.025 232.329L489.356 259.72C497.049 263.823 505.854 266.045 515.128 265.874C542.78 265.361 565.175 243.738 567.696 216.603L537.01 215.449Z",
    fill: "url(#paint24_linear_679_819)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M484.229 256.601L500.94 229.209C495.897 225.064 492.691 218.782 492.691 211.689C492.691 209.979 492.862 208.313 493.247 206.689L463.159 195.536C461.577 200.664 460.723 206.133 460.723 211.774C460.723 230.448 470.04 246.9 484.229 256.601Z",
    fill: "url(#paint25_linear_679_819)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M518.504 189.255C528.548 190.836 536.326 199.126 537.266 209.467L588.083 211.476C588.083 211.433 588.083 211.433 588.083 211.39C588.083 172.034 558.037 139.3 519.401 136.395L518.504 189.255Z",
    fill: "url(#paint26_linear_679_819)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M531.882 316.385C528.976 280.746 550.858 266.046 542.524 233.74C532.224 193.828 492.52 192.119 478.971 152.976C474.014 138.617 471.92 117.166 484.827 86.3127L430.677 84.5606C429.053 84.5179 427.771 85.7572 427.771 87.3383V398.688C427.771 400.269 429.095 401.509 430.677 401.423L579.023 393.176C543.892 364.374 533.634 337.41 531.882 316.385Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M479.143 166.522L369.091 165.453C366.612 165.411 364.604 163.445 364.604 161.009V119.174C364.604 116.738 366.612 114.858 369.091 114.901L464.911 117.165C467.262 117.208 469.185 119.174 469.185 121.524V157.505L479.143 166.522Z",
    fill: "url(#paint27_linear_679_819)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M453.671 132.293L380.802 130.883V125.84L453.671 127.379V132.293Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M453.671 142.121L380.802 140.925V135.882L453.671 137.207V142.121Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M453.671 151.95L380.802 150.924V145.924L453.671 147.035V151.95Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M515.684 276.943L589.922 275.361C591.845 275.319 593.426 276.9 593.426 278.908V313.479C593.426 315.487 591.845 317.154 589.922 317.197L511.71 319.846C509.701 319.932 508.034 318.308 508.034 316.257V271.045L515.684 276.943Z",
    fill: "url(#paint28_linear_679_819)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M521.241 306.171L580.733 304.419V308.564L521.241 310.444V306.171Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M521.241 297.71L580.733 296.043V300.231L521.241 301.941V297.71Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M521.241 289.206L580.733 287.71V291.898L521.241 293.437V289.206Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M528.677 332.24L666.082 326.3L824.386 331.812L668.219 365.956L528.677 332.24Z",
    fill: "url(#paint29_linear_679_819)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M639.37 464.625L528.078 434.67C516.881 431.636 508.162 420.568 508.162 409.799V409.671C508.162 398.903 516.881 391.681 528.078 393.646L647.447 413.175L639.37 464.625Z",
    fill: "url(#paint30_linear_679_819)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M824.557 442.148L644.713 462.232C633.43 463.472 624.198 455.652 624.198 444.669V437.234C624.198 426.252 633.473 416.637 644.713 415.739L824.557 401.424C816.608 416.252 814.77 430.097 824.557 442.148Z",
    fill: "#EAEAEA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M826.138 444.157L646.251 464.541C631.549 466.207 619.368 455.909 619.368 441.593V441.422C619.368 427.064 631.549 414.458 646.251 413.304L826.138 399.288C827.206 399.202 828.104 400.1 828.104 401.296C828.104 402.493 827.249 403.518 826.138 403.604L646.251 418.261C634.412 419.244 624.668 429.372 624.668 440.909V441.08C624.668 452.618 634.412 460.908 646.251 459.584L826.138 439.798C827.206 439.67 828.104 440.568 828.104 441.764C828.104 442.961 827.206 444.029 826.138 444.157Z",
    fill: "url(#paint31_linear_679_819)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M644.07 413.304L528.12 393.647C516.923 391.681 508.204 376.981 508.204 360.828V360.658C508.204 344.505 516.923 331.642 528.12 332.069L651.122 336.642L644.07 413.304Z",
    fill: "url(#paint32_linear_679_819)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M824.556 396.126L654.798 408.946C638.045 410.228 624.197 397.921 624.197 381.469V370.315C624.197 353.863 638.045 340.146 654.798 339.676L824.556 335.061C816.564 357.197 814.812 378.007 824.556 396.126Z",
    fill: "#EAEAEA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M826.137 399.287L646.25 413.304C631.548 414.457 619.367 397.877 619.367 376.34V376.126C619.367 354.589 631.548 336.769 646.25 336.385L826.137 331.898C827.205 331.855 828.103 333.308 828.103 335.103C828.103 336.898 827.248 338.393 826.137 338.393L646.25 343.778C634.411 344.119 624.667 358.478 624.667 375.784V376.041C624.667 393.347 634.411 406.68 646.25 405.825L826.137 392.706C827.205 392.621 828.103 394.031 828.103 395.826C828.103 397.621 827.205 399.202 826.137 399.287Z",
    fill: "url(#paint33_linear_679_819)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M608.085 397.108L583.297 392.792C577.527 376.981 577.954 362.494 583.297 345.145L608.085 346.897C602.999 365.144 603.768 381.681 608.085 397.108Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M620.737 325.7C620.737 325.7 612.403 329.503 612.232 330.144C612.103 330.743 617.617 329.931 619.882 330.016C622.147 330.101 623.985 329.418 623.771 328.478C623.557 327.538 622.788 325.145 622.788 325.145L620.737 325.7Z",
    fill: "url(#paint34_linear_679_819)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M620.437 322.624L620.949 326.384C620.949 326.384 622.274 326.854 623.172 326.299L623.556 322.154L620.437 322.624Z",
    fill: "url(#paint35_linear_679_819)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M659.799 322.624L660.782 324.162C661.039 324.589 661.124 325.145 660.996 325.615C660.654 326.897 659.97 329.461 659.671 330.102C659.286 330.999 653.859 331.555 653.859 331.555C653.859 331.555 653.388 330.871 654.5 330.059C655.611 329.247 656.337 329.119 656.722 327.88C657.107 326.683 657.363 323.265 657.363 323.265L659.799 322.624Z",
    fill: "url(#paint36_linear_679_819)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M655.74 318.65C656.082 318.949 657.834 324.205 657.834 324.205C657.834 324.205 658.39 324.932 659.458 323.863C660.527 322.795 659.929 323.393 659.929 323.393L659.715 318.223L655.74 318.65Z",
    fill: "url(#paint37_linear_679_819)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M615.65 246.987C615.222 258.225 615.265 270.404 615.906 283.438C616.675 298.095 618.171 311.684 620.052 323.991C620.735 323.991 621.462 324.034 622.189 323.991C622.701 323.991 623.172 323.948 623.684 323.905C624.625 321.341 625.736 318.008 626.762 313.991C627.83 309.761 628.428 306 628.899 302.368C630.48 289.634 628.599 288.523 629.882 279.122C631.035 270.789 632.66 270.447 634.583 258.567C636.634 245.705 635.096 243.782 634.326 243.098C631.035 240.15 623.471 242.158 615.65 246.987Z",
    fill: "url(#paint38_linear_679_819)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M634.285 243.099C631.208 240.279 624.156 241.988 616.72 246.347C625.31 255.577 626.25 261.559 625.225 265.491C624.071 269.892 620.566 271.174 620.566 276.003C620.609 281.9 625.951 283.481 625.823 289.72C625.738 293.865 623.43 293.823 622.874 298.95C622.233 305.018 625.31 307.07 624.327 311.557C623.9 313.48 622.703 316.001 619.241 318.607C619.498 320.445 619.754 322.282 620.011 324.034C620.694 324.034 621.421 324.077 622.148 324.034C622.66 324.034 623.13 323.992 623.643 323.949C624.584 321.385 625.695 318.052 626.721 314.035C627.789 309.805 628.387 306.044 628.857 302.412C630.439 289.677 628.558 288.566 629.84 279.165C630.994 270.832 632.618 270.49 634.542 258.611C636.593 245.706 635.055 243.783 634.285 243.099Z",
    fill: "url(#paint39_linear_679_819)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M620.95 246.773C628.344 257.542 636.336 270.96 643.473 286.985C648.859 299.121 652.79 310.53 655.697 320.658C656.081 320.829 656.979 321.171 658.176 321.042C659.757 320.829 660.74 319.803 660.954 319.504C662.108 312.197 661.937 306.043 661.552 301.599C661.295 298.736 660.825 293.993 658.988 288.138C656.936 281.558 655.526 281.216 652.876 274.293C650.098 267.071 650.782 265.276 648.089 256.26C646.978 252.542 645.183 247.03 642.149 240.449C635.097 242.585 628.002 244.679 620.95 246.773Z",
    fill: "url(#paint40_linear_679_819)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M590.863 231.604C590.948 234.21 595.222 236.518 598.727 237.244C606.847 238.911 616.249 233.014 620.694 226.476C621.592 225.194 622.532 223.655 622.788 223.783C623.301 224.04 618.429 232.074 616.335 241.176C615.266 245.834 615.523 248.013 613.514 251.132C613.044 251.816 612.488 252.585 612.702 253.397C613.215 255.491 617.959 256.004 621.25 256.388C624.754 256.773 628.003 256.73 631.208 256.688C636.337 256.602 636.764 256.346 637.918 256.901C641.508 258.653 641.251 262.884 643.944 263.439C646.209 263.909 648.517 261.388 649.244 260.576C653.047 256.431 652.834 251.389 653.475 246.346C655.013 234.595 661.424 221.69 667.707 213.528C669.587 211.049 670.912 209.767 670.998 207.46C671.254 200.708 660.527 193.23 651.637 192.375C649.201 192.161 644.799 192.204 640.739 192.589C639.115 192.76 637.362 192.973 635.482 193.315C630.951 194.127 627.746 194.683 624.541 196.135C611.548 202.075 614.369 215.322 600.265 224.51C595.436 227.629 590.82 228.826 590.863 231.604Z",
    fill: "url(#paint41_linear_679_819)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M644.2 185.324C644.2 185.324 644.756 188.443 646.038 190.665C647.192 192.674 652.022 193.4 653.005 193.742C653.988 194.084 651.509 195.836 648.816 196.477C646.124 197.118 638.345 197.503 636.807 196.691C635.268 195.836 637.79 195.58 639.627 194.639C641.465 193.657 642.063 189.725 641.508 188.059C640.952 186.392 644.2 185.324 644.2 185.324Z",
    fill: "url(#paint42_linear_679_819)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M639.114 184.426C637.191 183.059 636.635 179.298 637.704 178.444C638.003 178.187 638.302 178.316 642.661 180.068C644.841 180.922 645.91 181.392 646.251 182.375C646.465 182.973 646.422 183.743 646.209 184.384C646.081 184.725 645.867 185.11 645.311 185.879C644.841 186.563 644.884 186.52 644.713 186.734C644.371 187.204 643.687 188.016 642.49 188.913C642.405 188.571 642.32 188.144 642.149 187.674C642.063 187.503 641.807 186.777 641.336 186.221C640.61 185.196 639.755 184.896 639.114 184.426Z",
    fill: "url(#paint43_linear_679_819)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M644.071 188.016C644.071 188.016 642.789 189.896 640.438 189.64C638.344 189.426 638.216 184.683 639.626 183.742C640.096 183.443 640.994 183.315 641.721 183.572C642.148 183.7 642.276 183.913 643.003 184.127C643.644 184.341 643.857 184.255 644.028 184.426C644.285 184.64 644.413 185.153 643.943 186.52C644.37 186.136 644.84 186.007 645.182 186.178C645.225 186.221 645.396 186.306 645.439 186.477C645.738 186.99 645.225 187.631 644.071 188.016Z",
    fill: "url(#paint44_linear_679_819)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M602.273 231.176C608.171 229.851 610.479 229.894 613.385 227.544C618.215 223.655 618.941 217.715 621.762 217.758C623.087 217.801 624.156 219.168 624.925 220.493C624.198 221.604 623.514 222.715 622.788 223.826C622.788 223.783 622.788 223.741 622.745 223.741C622.532 223.612 621.549 225.194 620.651 226.433C616.206 232.971 606.804 238.825 598.683 237.201C596.375 236.731 593.64 235.535 592.102 233.996C596.162 232.672 599.581 231.774 602.273 231.176Z",
    fill: "url(#paint45_linear_679_819)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M592.657 236.261C592.657 236.261 589.323 235.919 587.357 235.064C585.391 234.21 584.109 235.449 584.28 236.261C584.451 237.115 587.699 238.269 589.024 238.312C590.349 238.355 592.657 236.261 592.657 236.261Z",
    fill: "url(#paint46_linear_679_819)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M664.158 253.782C667.706 254.081 675.74 254.252 681.425 248.995C690.87 240.278 686.169 223.655 682.878 216.476C679.117 208.271 673.091 203.699 669.458 200.921C664.928 197.46 662.192 195.366 658.859 195.836C650.268 197.075 644.328 214.638 649.029 219.681C650.567 221.347 652.106 220.407 656.551 221.818C658.004 222.288 668.86 225.749 670.74 233.74C672.065 239.338 668.689 245.876 662.705 250.277C663.218 251.474 663.688 252.628 664.158 253.782Z",
    fill: "url(#paint47_linear_679_819)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M624.198 250.876C628.216 248.312 628.814 245.748 633.345 243.996C639.2 241.731 642.021 244.594 644.927 242.287C648.389 239.509 645.311 234.68 647.918 226.347C648.346 224.937 651.679 214.126 659.372 212.758C662.962 212.117 667.664 213.485 669.501 216.519C670.912 218.869 669.587 220.664 671.339 223.271C673.049 225.877 675.143 225.236 677.323 227.416C680.827 230.877 681.34 238.184 678.22 242.287C676.767 244.21 674.844 244.979 671.211 246.389C668.989 247.244 666.98 247.799 665.185 248.141C669.587 243.91 671.895 238.441 670.741 233.655C669.544 228.655 664.886 225.45 661.21 223.612C657.492 230.578 654.5 238.654 653.474 246.261C652.791 251.303 653.004 256.346 649.243 260.491C648.517 261.303 646.209 263.824 643.944 263.354C641.251 262.798 641.508 258.568 637.918 256.816C636.764 256.26 636.336 256.517 631.208 256.602C628.002 256.645 624.754 256.687 621.25 256.303C618.301 255.961 614.24 255.491 613.001 253.953C618.301 253.867 621.848 252.372 624.198 250.876Z",
    fill: "url(#paint48_linear_679_819)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M661.808 256.602L662.236 255.362C662.877 253.397 661.809 251.345 659.8 250.747L581.289 226.817L578.896 234.936L657.022 258.995C658.988 259.593 661.125 258.525 661.808 256.602Z",
    fill: "url(#paint49_linear_679_819)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M503.247 204.853C509.23 181.136 532.779 166.863 556.029 173.53C579.707 180.367 593.297 206.006 586.075 230.193C579.066 253.824 554.961 266.559 532.438 259.251C510.384 252.158 497.392 228.014 503.247 204.853ZM579.279 228.142C585.22 207.887 573.894 186.435 554.106 180.709C534.617 175.025 514.829 186.948 509.701 206.861C504.7 226.39 515.641 246.731 534.275 252.756C553.251 258.781 573.424 247.97 579.279 228.142Z",
    fill: "url(#paint50_linear_679_819)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M581.288 226.817L591.289 229.851C591.973 233.056 593.298 234.851 594.665 236.004C599.709 240.192 606.461 235.62 615.906 240.534C620.65 243.013 619.753 244.551 624.155 246.303C631.463 249.166 634.84 245.192 641.336 247.799C647.875 250.405 648.559 256.089 652.277 255.875C653.858 255.79 655.91 254.636 658.218 250.234L659.842 250.747C661.851 251.345 662.919 253.439 662.278 255.362L661.851 256.602C661.209 258.525 659.03 259.593 657.064 258.995L578.938 234.936L581.288 226.817Z",
    fill: "#D8D8E8"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M532.437 255.961C552.011 262.285 572.953 251.089 578.979 230.578C585.134 209.596 573.381 187.418 552.909 181.435C532.736 175.581 512.264 187.888 506.965 208.528C501.836 228.697 513.162 249.765 532.437 255.961Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M501.752 206.904C507.735 183.187 531.284 168.915 554.534 175.581C578.211 182.418 591.802 208.058 584.579 232.244C577.57 255.876 553.466 268.61 530.942 261.303C508.846 254.166 495.897 230.065 501.752 206.904ZM577.741 230.193C583.682 209.938 572.356 188.486 552.568 182.76C533.079 177.077 513.291 188.999 508.163 208.912C503.162 228.441 514.103 248.782 532.737 254.807C551.713 260.832 571.929 250.021 577.741 230.193Z",
    fill: "url(#paint51_linear_679_819)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M504.017 207.588C509.701 185.238 531.925 171.778 553.85 178.102C576.16 184.555 588.939 208.699 582.186 231.518C575.604 253.824 552.867 265.875 531.626 258.995C510.727 252.286 498.461 229.467 504.017 207.588ZM577.741 230.193C583.682 209.938 572.356 188.486 552.568 182.76C533.079 177.076 513.291 188.999 508.162 208.912C503.162 228.441 514.103 248.782 532.737 254.807C551.713 260.832 571.929 250.021 577.741 230.193Z",
    fill: "url(#paint52_linear_679_819)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M663.86 253.055L663.048 251.089C663.048 251.089 661.765 251.174 660.697 250.405C660.099 249.978 659.073 249.85 658.774 249.935C658.475 250.021 657.363 249.978 658.645 250.576C659.928 251.174 659.928 251.644 659.372 252.157C658.816 252.67 656.808 253.738 656.081 253.781C655.355 253.824 656.679 254.978 657.406 255.106C658.133 255.234 659.372 255.448 660.868 254.55C661.423 254.251 663.86 253.055 663.86 253.055Z",
    fill: "url(#paint53_linear_679_819)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M234.422 486.59C248.325 486.59 259.595 481.998 259.595 476.334C259.595 470.67 248.325 466.078 234.422 466.078C220.519 466.078 209.249 470.67 209.249 476.334C209.249 481.998 220.519 486.59 234.422 486.59Z",
    fill: "#B7B7CE"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M209.249 475.138C209.249 480.48 220.532 484.838 234.422 484.838C248.312 484.838 259.595 480.48 259.595 475.138C259.595 469.796 248.312 461.036 234.422 461.036C220.532 460.994 209.249 469.754 209.249 475.138Z",
    fill: "#EBECF2"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M209.249 475.138C209.249 469.796 220.532 461.036 234.422 461.036C240.833 461.036 246.688 462.916 251.133 465.438C251.432 466.079 251.603 466.72 251.518 467.361C251.218 470.352 246.303 472.232 243.483 472.83C236.388 474.369 232.926 470.138 227.071 470.266C223.438 470.352 218.438 472.189 212.497 479.881C210.446 478.471 209.249 476.847 209.249 475.138Z",
    fill: "#EBECF2"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M233.055 467.702C234.08 467.958 234.978 467.958 235.875 467.702C236.687 467.488 237.243 466.762 237.243 465.95V441.806H231.644V465.907C231.602 466.762 232.2 467.488 233.055 467.702Z",
    fill: "#D8D8E8"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M263.998 434.755L255.45 429.371C255.108 427.363 254.98 356.17 238.611 349.504C231.944 346.812 214.592 350.059 210.66 350.23C202.796 350.572 197.24 350.829 194.547 354.589C191.085 359.375 203.18 410.911 201.984 424.628C201.514 430.226 200.231 432.704 201.813 436.422C203.651 440.866 207.967 443.345 211.344 444.712C215.361 447.02 222.327 450.353 231.516 451.165C247.03 452.532 258.612 445.866 262.587 443.345C264.339 442.789 265.707 441.336 266.049 439.499C266.391 437.661 265.579 435.781 263.998 434.755Z",
    fill: "url(#paint54_linear_679_819)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M208.908 351.384C203.095 351.555 199.505 351.47 197.497 354.077C195.403 356.812 203.822 406.253 204.207 415.911C204.549 424.714 203.01 428.218 205.874 433.132C205.874 433.132 207.327 435.611 209.592 437.491C217.669 444.072 238.526 443.986 247.33 430.226C254.339 419.244 245.108 355.914 236.859 350.53C232.884 347.923 231.944 350.701 208.908 351.384Z",
    fill: "url(#paint55_linear_679_819)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M264.597 429.927L256.049 424.543C256.049 424.543 233.141 417.022 211.943 427.62C209.549 428.816 208.096 431.252 208.096 433.902C208.096 435.953 209.336 437.79 211.216 438.559C214.892 441.081 222.114 445.268 232.073 446.337C247.886 448.089 259.639 440.824 263.144 438.517C264.896 437.961 266.264 436.508 266.605 434.671C266.99 432.791 266.178 430.91 264.597 429.927Z",
    fill: "url(#paint56_linear_679_819)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M301.864 496.975L294.556 492.574H291.265C291.265 492.574 290.154 496.762 290.282 496.975C291.735 499.368 298.573 501.206 302.847 501.377C303.574 501.419 304.557 501.419 304.813 500.907C305.24 500.009 303.317 498.214 301.864 496.975Z",
    fill: "url(#paint57_linear_679_819)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M294.427 487.83C294.427 490.394 294.513 492.189 295.154 493.001C295.624 493.556 291.265 494.795 291.265 492.616C291.265 491.163 291.008 488.727 290.794 488.001C292.034 487.916 293.231 487.873 294.427 487.83Z",
    fill: "url(#paint58_linear_679_819)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M274.725 503.171L267.417 498.769H264.126C264.126 498.769 263.015 502.957 263.143 503.171C264.596 505.564 271.434 507.401 275.708 507.572C276.435 507.615 277.418 507.615 277.674 507.102C278.102 506.205 276.136 504.367 274.725 503.171Z",
    fill: "url(#paint59_linear_679_819)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M267.289 493.983C267.289 496.547 267.374 498.342 268.015 499.154C268.485 499.709 264.126 500.948 264.126 498.769C264.126 497.316 263.869 494.88 263.656 494.154C264.852 494.111 266.092 494.026 267.289 493.983Z",
    fill: "url(#paint60_linear_679_819)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M294.726 489.966C296.778 477.488 294.769 464.199 294.299 457.019C293.53 445.653 293.188 439.926 289.897 435.14C285.58 428.859 276.733 422.62 269.297 417.321C268.656 416.851 267.374 415.953 265.749 414.543C261.732 410.954 259.168 407.193 257.629 404.544C240.747 399.587 225.148 401.595 218.267 410.655C217.455 411.723 215.489 413.988 215.104 417.321C214.249 424.885 221.643 433.987 229.977 435.867C240.576 438.26 246.688 427.406 256.091 431.038C257.031 431.38 259.809 434.157 265.408 439.585C269.468 443.516 271.519 445.439 272.16 446.251C278.144 453.473 281.734 464.54 282.161 473.13C282.247 474.668 282.289 477.83 284.127 481.249C285.537 483.856 289.384 488.599 290.794 489.71C292.119 489.753 293.444 489.838 294.726 489.966Z",
    fill: "url(#paint61_linear_679_819)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M263.143 496.12C263.143 496.12 266.776 497.83 269.425 496.12C269.34 491.591 269.34 484.54 269.896 475.865C271.178 456.934 273.828 451.208 271.477 443.132C269.767 437.32 265.152 429.372 251.561 421.936L217.028 418.561C217.028 418.561 215.404 421.21 215.788 424.885C216.515 431.594 224.251 435.739 230.704 439.072C243.44 445.739 246.133 442.662 250.321 447.149C255.92 453.217 252.458 460.31 255.493 475.31C257.33 484.326 260.579 491.42 263.143 496.12Z",
    fill: "url(#paint62_linear_679_819)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M267.587 408.048C272.331 407.621 279.469 385.229 269.553 370.786C262.245 360.145 246.987 355.744 244.337 358.991C242.799 360.872 245.961 364.718 251.859 375.785C263.912 398.519 264.425 408.348 267.587 408.048Z",
    fill: "url(#paint63_linear_679_819)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M215.062 360.059C219.336 358.691 225.832 357.067 233.781 356.982C242.714 356.897 249.851 356.811 254.766 360.572C266.647 369.674 253.356 392.108 260.151 408.389C260.878 410.184 263.057 415.825 261.177 422.021C260.835 423.175 260.108 424.158 258.869 425.867C251.646 435.866 231.217 437.405 221.814 429.157C216.814 424.799 212.284 425.739 212.155 420.568C211.728 400.142 215.275 379.716 215.062 360.059Z",
    fill: "url(#paint64_linear_679_819)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M224.036 385.912C222.327 381.682 224.079 376.767 220.275 374.716C218.865 373.947 215.403 371.81 215.232 373.733C213.822 386.297 212.582 399.245 213.009 414.885C213.138 420.056 217.07 424.756 222.583 429.115C228.994 434.157 239.935 435.482 249.295 433.474C237.029 427.021 228.267 420.141 229.507 413.988C230.96 406.808 245.277 404.373 244.722 399.33C244.081 393.989 227.797 395.142 224.036 385.912Z",
    fill: "url(#paint65_linear_679_819)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M234.637 345.83C234.679 348.864 234.295 351.257 233.953 352.881C233.568 354.761 233.269 355.231 232.884 355.659C232.329 356.257 231.474 356.77 226.73 357.881C224.123 358.479 223.781 358.479 223.738 358.735C223.439 359.889 230.534 363.692 237.842 362.624C242.287 361.983 246.347 359.633 246.09 358.436C245.834 357.24 241.389 357.923 240.064 355.744C239.124 354.206 240.193 352.026 241.389 350.189C240.193 348.223 235.833 347.839 234.637 345.83Z",
    fill: "url(#paint66_linear_679_819)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M243.997 349.59C245.365 348.607 246.048 346.47 245.236 344.847C244.553 343.436 243.014 342.924 242.116 342.582C239.467 341.642 235.663 341.898 233.782 343.949C232.671 345.146 233.398 348.351 233.526 348.949C233.654 349.59 234.082 349.889 234.423 350.445C234.894 351.214 235.62 352.41 236.774 354.376C237.031 353.949 237.415 353.393 237.885 352.795C238.056 352.581 238.826 351.727 239.766 351.086C241.646 349.804 242.672 350.53 243.997 349.59Z",
    fill: "url(#paint67_linear_679_819)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M234.85 352.496C234.85 352.496 235.876 355.616 239.551 356.214C242.842 356.769 245.193 350.274 243.526 348.394C242.97 347.753 241.645 347.283 240.449 347.283C239.722 347.283 239.466 347.496 238.269 347.496C237.201 347.496 236.944 347.325 236.559 347.496C236.089 347.71 235.619 348.351 235.705 350.445C235.235 349.718 234.593 349.334 233.995 349.462C233.91 349.462 233.653 349.548 233.44 349.761C232.798 350.402 233.269 351.513 234.85 352.496Z",
    fill: "url(#paint68_linear_679_819)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M236.559 347.069C236.688 347.197 236.047 347.624 235.79 348.394C235.32 349.846 236.431 351.94 238.013 352.453C238.953 352.752 239.38 352.282 241.047 352.496C242.073 352.624 242.885 352.923 243.355 353.137C243.398 354.846 242.457 356.342 241.09 356.812C239.594 357.325 238.141 356.47 237.542 356.128C237.115 355.872 235.79 355.145 235.406 353.778C234.978 352.325 235.961 351.769 235.32 350.701C234.978 350.188 234.423 349.846 234.081 348.864C233.995 348.607 233.952 348.394 233.91 348.223C234.978 347.624 236.346 346.898 236.559 347.069Z",
    fill: "url(#paint69_linear_679_819)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M242.03 353.479C242.03 353.479 241.261 353.65 240.064 353.308C240.021 353.308 239.936 353.308 239.936 353.308C239.893 353.394 240.534 354.035 241.26 354.035C241.816 354.035 242.329 353.693 242.286 353.565C242.243 353.522 242.158 353.479 242.03 353.479Z",
    fill: "url(#paint70_linear_679_819)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M329.003 497.871H328.96C328.661 497.828 328.404 497.615 328.404 497.273V403.731C328.404 403.389 328.661 403.133 329.003 403.133C329.345 403.133 329.601 403.389 329.601 403.731V489.709L342.636 405.654C342.679 405.355 342.978 405.099 343.32 405.184C343.619 405.227 343.876 405.526 343.79 405.868L329.601 497.401C329.515 497.657 329.302 497.871 329.003 497.871Z",
    fill: "#B7B7CE"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M170.871 415.525L326.439 403.518L402.856 410.269L293.531 426.251L170.871 415.525Z",
    fill: "#F4F4FA"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M293.53 426.252L170.87 415.526V420.696L293.53 431.422L402.856 415.483V410.27L293.53 426.252Z",
    fill: "#B7B7CE"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M292.461 529.792C292.162 529.792 291.905 529.578 291.905 529.279L278.4 429.755C278.357 429.456 278.571 429.157 278.913 429.114C279.212 429.071 279.511 429.285 279.554 429.627L291.905 520.562V429.67C291.905 429.328 292.162 429.071 292.504 429.071C292.846 429.071 293.102 429.328 293.102 429.67V529.194C293.059 529.493 292.803 529.749 292.461 529.792C292.504 529.792 292.504 529.792 292.461 529.792Z",
    fill: "#B7B7CE"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M401.146 508.682C400.847 508.682 400.59 508.469 400.59 508.169L388.068 416.722C388.025 416.422 388.239 416.123 388.581 416.081C388.88 416.038 389.179 416.251 389.222 416.593L400.548 499.537V413.047C400.548 412.705 400.804 412.448 401.146 412.448C401.488 412.448 401.744 412.705 401.744 413.047V508.127C401.702 508.426 401.488 508.682 401.146 508.682Z",
    fill: "#B7B7CE"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M172.365 511.503H172.323C172.024 511.46 171.767 511.246 171.767 510.904V420.696C171.767 420.354 172.024 420.097 172.365 420.097C172.707 420.097 172.964 420.354 172.964 420.696V502.956L185.059 420.61C185.102 420.311 185.401 420.055 185.7 420.097C185.999 420.14 186.256 420.439 186.213 420.738L172.964 510.947C172.878 511.289 172.622 511.503 172.365 511.503Z",
    fill: "#B7B7CE"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M227.798 413.731C228.78 412.663 229.721 411.594 230.704 410.526C223.224 400.698 217.241 396.424 213.053 394.416C210.146 393.006 210.275 392.108 210.146 391.766C209.42 389.715 217.284 380.741 219.335 378.006C223.096 373.007 226.686 364.417 223.908 360.999C221.002 357.409 211.771 360.101 206.898 362.452C202.582 364.546 199.718 367.323 198.222 369.033C193.607 374.203 184.76 388.134 190.444 400.698C195.701 412.321 211.771 419.115 227.798 413.731Z",
    fill: "url(#paint71_linear_679_819)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M248.953 413.646V412.321L306.223 409.245V410.569L265.749 414.543L248.953 413.646Z",
    fill: "url(#paint72_linear_679_819)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M248.953 412.321L266.69 412.534L306.223 409.244L295.196 408.56L248.953 412.321Z",
    fill: "url(#paint73_linear_679_819)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M256.518 407.748L272.631 357.323C272.887 356.512 273.784 355.956 274.81 355.913L345.372 354.631C345.97 354.631 346.996 355.059 347.381 355.443C347.765 355.828 348.235 355.913 348.107 356.383L334.944 400.74C334.73 401.466 333.918 402.065 333.02 402.15L257.8 409.03L256.518 407.748Z",
    fill: "url(#paint74_linear_679_819)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M257.843 409.03L274.169 358.264C274.426 357.452 275.323 356.896 276.349 356.896L346.74 355.572C347.338 355.572 347.894 355.785 348.278 356.17C348.663 356.555 348.791 357.067 348.62 357.537L336.354 401.552C336.141 402.321 335.329 402.877 334.388 402.962L257.843 409.03Z",
    fill: "url(#paint75_linear_679_819)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M257.843 409.03L334.388 403.005C335.328 402.919 336.141 402.364 336.354 401.595L340.072 388.305C316.737 396.467 289 395.569 261.519 397.62L257.843 409.03Z",
    fill: "url(#paint76_linear_679_819)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M302.805 417.534L299.898 418.517C299.898 418.517 284.641 415.654 283.957 415.183C283.871 415.098 283.487 414.414 284.171 414.286C287.761 413.688 300.924 413.218 300.924 413.218L302.121 413.303L302.805 417.534Z",
    fill: "url(#paint77_linear_679_819)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M303.018 416.636L300.111 417.619C300.111 417.619 284.854 414.756 284.17 414.286C283.486 413.816 301.137 412.32 301.137 412.32L302.334 412.406L303.018 416.636Z",
    fill: "url(#paint78_linear_679_819)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M315.669 381.596C315.669 381.596 323.063 413.475 323.277 415.312C323.49 417.022 305.284 418.731 300.882 418.859C300.497 418.859 300.027 418.603 299.899 418.517C298.702 418.389 304.343 382.024 304.343 382.024H304.771L315.669 381.596Z",
    fill: "url(#paint79_linear_679_819)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M315.669 381.596C315.669 381.596 324.088 413.774 324.302 415.654C324.516 417.534 302.847 418.945 300.967 418.859C299.77 418.731 304.77 382.066 304.77 382.066L315.669 381.596Z",
    fill: "url(#paint80_linear_679_819)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M230.661 412.321C230.661 412.321 235.448 410.141 238.226 410.312C241.004 410.526 244.893 413.047 245.577 414.543C246.26 416.038 236.174 415.868 236.174 415.868C236.174 415.868 224.207 415.397 230.661 412.321Z",
    fill: "url(#paint81_linear_679_819)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M228.183 409.757C230.875 406.338 237.243 408.432 237.628 408.56C239.167 409.073 241.218 410.141 241.047 410.825C240.919 411.466 238.867 411.124 235.448 411.722C230.491 412.577 228.268 414.415 227.371 413.474C226.73 412.705 227.285 410.868 228.183 409.757Z",
    fill: "url(#paint82_linear_679_819)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M756.688 270.405C754.978 269.294 756.517 266.089 756.645 259.167C756.773 250.663 754.508 249.082 756.303 245.791C758.526 241.732 764.082 240.022 767.8 239.937C768.612 239.937 768.826 239.467 775.621 241.262C787.93 244.424 791.007 241.048 796.478 244.424C801.777 247.714 799.469 251.304 804.641 255.192C813.017 261.431 821.822 254.68 827.805 259.936C833.446 264.893 833.575 277.499 827.634 284.379C820.881 292.199 808.701 289.849 800.58 288.31C798.871 287.968 790.195 286.174 781.177 279.507C776.177 275.832 772.758 271.901 770.578 268.995C770.065 268.44 769.253 267.713 768.227 267.628C766.945 267.499 765.962 268.269 765.449 268.611C762.842 270.32 758.355 271.516 756.688 270.405Z",
    fill: "url(#paint83_linear_679_819)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M763.57 265.747C761.39 263.739 753.526 267.585 748.312 272.713C742.2 278.738 742.67 283.609 737.328 291.088C734.678 294.805 730.148 299.805 722.07 304.207C722.626 305.617 723.224 307.07 723.78 308.48C727.669 308.693 735.319 308.565 742.457 303.907C747.414 300.66 749.936 296.386 754.851 287.968C759.766 279.507 766.305 268.268 763.57 265.747Z",
    fill: "url(#paint84_linear_679_819)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M715.532 383.391L718.011 378.092C718.352 377.322 718.908 376.682 719.592 376.211L720.831 375.4C720.831 375.4 723.78 375.314 724.25 377.194C724.336 379.545 719.763 384.843 716.857 386.937C716.386 387.279 715.703 387.749 715.275 387.493C714.634 387.108 715.104 384.929 715.532 383.391Z",
    fill: "url(#paint85_linear_679_819)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M720.232 372.536C720.617 374.801 720.146 375.997 719.591 376.681C719.206 377.151 716.129 382.194 717.411 383.006C717.967 383.39 721.856 378.519 722.241 377.792C722.583 377.109 722.796 377.279 722.839 375.442C722.839 374.245 723.096 373.263 723.309 372.664C722.283 372.622 721.258 372.579 720.232 372.536Z",
    fill: "url(#paint86_linear_679_819)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M715.83 354.46C715.83 354.46 713.052 357.751 713.522 361.383C713.992 365.015 718.822 359.716 719.506 357.922C720.19 356.127 720.959 353.606 720.959 353.606C720.959 353.606 717.54 351.469 715.83 354.46Z",
    fill: "url(#paint87_linear_679_819)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M716.855 349.29C716.855 349.29 717.624 353.135 716.171 355.144C715.445 356.17 714.504 357.024 714.761 357.836C714.932 358.392 715.658 358.776 716.3 358.733C717.453 358.605 718.095 356.811 718.565 355.571C719.249 353.691 719.633 349.717 719.633 349.717L716.855 349.29Z",
    fill: "url(#paint88_linear_679_819)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M719.079 352.537C718.225 352.238 717.37 351.896 716.515 351.597C715.19 348.563 713.566 343.606 714.122 337.538C715.532 321.983 729.892 313.736 731.516 312.838C735.448 314.804 739.423 317.582 739.551 321.086C739.722 325.487 733.739 327.795 728.14 334.205C724.721 338.093 721.131 343.862 719.079 352.537Z",
    fill: "url(#paint89_linear_679_819)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M720.019 374.288C717.199 363.306 717.925 354.332 718.737 349.204C719.977 341.384 722.455 325.531 733.055 319.633C735.363 318.351 738.696 317.198 742.714 313.608C746.09 310.617 748.227 307.455 749.509 305.233C763.698 301.087 776.734 302.754 782.503 310.36C783.187 311.258 784.854 313.138 785.153 315.958C785.88 322.283 779.64 329.932 772.673 331.513C763.784 333.522 758.655 324.419 750.791 327.453C748.612 328.308 746.731 330.402 743.013 334.59C738.269 339.931 735.576 344.888 734.593 346.854C731.602 352.751 729.294 357.067 728.994 362.708C728.909 364.033 728.866 366.682 727.328 369.502C726.131 371.682 724.55 373.177 723.353 374.075C722.199 374.118 721.088 374.203 720.019 374.288Z",
    fill: "url(#paint90_linear_679_819)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M785.152 315.915C784.81 313.095 783.143 311.214 782.502 310.317C776.732 302.711 763.654 301.044 749.508 305.189C748.225 307.411 746.089 310.573 742.712 313.565C738.695 317.154 735.361 318.308 733.053 319.59C726.6 323.222 723.138 330.53 721.172 337.452C724.121 332.88 726.642 331.683 728.566 331.641C731.344 331.598 732.583 333.991 735.917 333.649C739.464 333.307 740.276 330.359 743.182 330.017C744.037 329.931 745.106 330.059 746.388 330.743C748.097 328.948 749.379 327.923 750.747 327.367C758.611 324.333 763.782 333.435 772.629 331.427C779.638 329.889 785.878 322.239 785.152 315.915Z",
    fill: "url(#paint91_linear_679_819)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M727.327 324.505C728.951 324.42 731.387 324.377 734.379 324.676C748.525 326.086 752.414 333.052 764.082 334.761C766.86 335.145 779.169 336.983 784.468 329.847C788.315 324.719 787.717 315.959 783.528 312.497C781.776 311.044 780.024 311.087 768.655 311.172C764.381 311.215 760.107 311.215 755.833 311.301C737.755 311.514 734.293 310.275 731.002 313.266C729.506 314.634 727.284 317.625 727.327 324.505Z",
    fill: "url(#paint92_linear_679_819)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M765.534 266.517C765.534 266.517 779.809 262.372 786.092 269.465C787.246 270.79 788.143 272.499 788.827 275.79C792.203 292.712 779.424 302.839 784.468 311.771C786.476 315.317 789.981 316.386 792.502 322.753C792.93 323.821 794.468 327.71 793.058 328.949C791.819 330.017 789.767 327.753 786.134 328.18C782.288 328.65 781.39 331.599 778.826 331.171C777.159 330.872 776.433 329.462 773.954 325.872C770.364 320.702 768.569 318.095 767.287 317.198C762.201 313.608 758.269 318.309 752.499 314.719C750.405 313.437 742.626 303.438 744.934 306.173C750.362 299.378 751.644 293.78 751.772 289.891C751.901 285.618 750.704 283.695 751.772 278.653C751.772 278.653 752.969 273.012 757.371 268.183C757.927 267.5 758.696 266.773 765.534 266.517Z",
    fill: "url(#paint93_linear_679_819)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M770.109 257.244C769.895 258.141 768.912 263.013 770.921 264.252C771.349 264.508 772.161 264.679 773.827 264.978C774.896 265.192 775.836 265.32 776.477 265.363C776.392 266.175 776.092 267.499 775.152 268.696C772.502 272.072 767.246 271.217 766.519 271.046C763.869 270.576 761.262 269.764 760.621 269.252C759.681 268.482 758.912 267.927 758.441 267.329C759.467 266.816 761.519 265.534 762.929 265.106C763.955 264.807 764.938 264.551 765.835 264.38C765.963 263.44 766.134 262.5 766.263 261.56C767.545 260.149 768.827 258.697 770.109 257.244Z",
    fill: "url(#paint94_linear_679_819)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M770.194 259.637C770.194 259.637 769.852 263.184 766.391 263.825C763.313 264.38 760.963 256.902 762.544 254.979C763.057 254.338 764.382 253.74 765.493 253.74C766.305 253.782 768.955 254.765 769.339 257.458C769.895 256.902 770.536 256.731 770.878 256.987C771.305 257.287 771.092 258.141 771.006 258.355C770.878 259.039 770.408 259.466 770.194 259.637Z",
    fill: "url(#paint95_linear_679_819)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M744.892 306.172C745.533 305.36 746.132 304.548 746.687 303.779C749.679 302.754 752.286 302.412 754.38 302.283C759.081 302.07 761.688 303.181 764.894 301.215C768.527 299.036 767.886 295.959 771.433 294.292C775.151 292.498 777.758 294.506 781.306 293.865C783.442 293.481 786.092 292.028 788.742 287.84C786.691 297.967 780.75 305.189 784.468 311.77C786.477 315.317 789.981 316.385 792.503 322.752C792.93 323.821 794.469 327.709 793.059 328.949C791.819 330.017 789.768 327.752 786.135 328.179C782.289 328.649 781.391 331.598 778.827 331.171C777.16 330.872 776.433 329.461 773.954 325.872C770.364 320.701 768.569 318.095 767.287 317.197C762.201 313.608 758.269 318.308 752.5 314.719C750.363 313.437 742.584 303.437 744.892 306.172Z",
    fill: "url(#paint96_linear_679_819)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M740.577 307.924L772.888 309.505C773.315 309.548 773.742 309.762 773.956 310.146L774.854 311.599C775.281 312.326 774.768 313.223 773.913 313.223L739.68 311.941L740.577 307.924Z",
    fill: "url(#paint97_linear_679_819)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M706.983 289.933L740.362 290.574C741.345 290.574 742.243 291.13 742.755 291.985L754.295 312.325L719.035 310.915C718.052 310.872 717.198 310.36 716.685 309.505L705.957 291.6C705.53 290.874 706.085 289.891 706.983 289.933Z",
    fill: "url(#paint98_linear_679_819)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M742.756 291.985C742.286 291.13 741.346 290.575 740.363 290.575H739.636C739.508 291.643 739.209 292.626 738.525 293.438C736.474 295.916 733.054 294.378 730.49 297.027C727.712 299.933 730.276 303.352 727.755 306.044C725.105 308.864 720.874 306.557 715.959 308.394L716.643 309.591C717.156 310.403 718.01 310.958 718.993 311.001L754.253 312.411L742.756 291.985Z",
    fill: "url(#paint99_linear_679_819)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M770.236 306.813C769.809 305.702 769.381 304.591 768.954 303.48C773.613 302.198 780.023 300.317 786.605 297.967C787.631 297.583 788.87 297.155 789.255 296.044C790.366 293.01 783.229 289.848 780.451 283.182C777.886 277.028 779.297 268.482 782.289 267.499C788.528 265.405 810.582 292.839 802.675 304.42C798.273 311.001 784.554 312.026 770.236 306.813Z",
    fill: "url(#paint100_linear_679_819)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M768.996 303.48C766.09 301.942 762.586 303.523 762.372 303.609C761.731 303.908 760.791 304.463 759.85 305.403C759.765 305.532 758.483 307.284 758.953 307.882C759.338 308.352 760.748 307.967 762.457 306.899C763.184 306.814 764.252 306.685 765.535 306.814C767.885 307.027 768.996 307.796 769.851 307.113C770.492 306.643 770.706 305.66 770.45 304.891C770.193 304.164 769.467 303.78 768.996 303.48Z",
    fill: "url(#paint101_linear_679_819)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M460.765 449.455C461.663 450.908 461.534 451.592 461.363 451.891C460.893 452.788 459.483 452.147 456.064 452.916C455.679 453.002 454.91 453.173 453.927 453.045C453.072 452.916 452.046 452.617 452.089 452.361C452.089 452.275 452.26 452.233 452.303 452.233C453.243 451.934 459.056 449.455 459.056 449.455H460.765Z",
    fill: "url(#paint102_linear_679_819)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M460.894 445.994L460.723 449.498C460.723 449.498 459.355 450.694 458.842 449.455C458.458 448.558 458.201 446.122 458.201 446.122L460.894 445.994Z",
    fill: "url(#paint103_linear_679_819)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M443.627 449.54L445.465 453.344L447.559 452.788L446.704 449.156L443.627 449.54Z",
    fill: "url(#paint104_linear_679_819)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M446.362 455.438C447.26 454.113 448.157 454.156 448.285 453.301C448.371 452.617 447.858 451.891 447.26 451.634C446.362 451.293 445.422 452.062 445.208 452.233C443.755 453.429 444.353 454.968 442.9 455.822C442.601 455.993 442.174 456.207 441.703 456.72C441.533 456.933 441.02 457.489 441.191 457.831C441.362 458.215 442.302 458.087 443.199 458.002C444.268 457.873 444.823 457.831 445.294 457.446C445.935 456.891 445.678 456.463 446.362 455.438Z",
    fill: "url(#paint105_linear_679_819)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M463.584 362.58C464.012 370.613 463.584 377.579 462.858 383.262C462.088 389.416 461.405 390.484 461.362 394.715C461.234 403.859 464.268 404.928 465.679 415.141C467.217 426.422 464.952 435.652 464.054 439.199C463.285 442.276 462.388 444.797 461.704 446.549C460.721 447.532 459.14 447.318 457.43 447.105C455.977 436.892 454.396 427.277 452.942 417.064C449.652 401.765 446.403 386.51 443.155 371.212C449.908 368.306 456.746 365.443 463.584 362.58Z",
    fill: "url(#paint106_linear_679_819)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M457.43 447.105C455.977 436.892 454.396 427.277 452.942 417.064C449.652 401.765 446.403 386.51 443.155 371.212C449.993 368.348 456.789 365.443 463.627 362.58C463.67 363.092 463.67 363.648 463.713 364.161C454.567 373.519 453.242 380.442 453.712 385.057C454.31 390.655 457.601 393.176 457.644 401.338C457.686 407.192 456.02 408.346 456.49 413.56C457.045 420.311 460.251 423.858 462.003 427.619C463.67 431.251 464.61 436.55 462.601 444.37C462.302 445.182 462.046 445.908 461.832 446.549C460.721 447.489 459.14 447.276 457.43 447.105Z",
    fill: "url(#paint107_linear_679_819)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M451.79 371.297C447.345 380.442 445.08 387.493 443.84 391.851C443.114 394.501 442.473 397.279 442.558 400.825C442.686 405.184 443.84 408.645 444.738 410.867C446.063 413.688 447.302 417.021 448.242 420.781C451.277 433.046 449.225 443.686 447.43 449.882C446.234 450.438 444.994 450.993 443.797 451.592C440.336 443.943 435.933 433.003 432.301 419.414C430.335 411.979 428.796 406.167 428.155 398.646C427.471 390.74 427.557 378.092 432.814 362.58C439.224 365.485 445.507 368.391 451.79 371.297Z",
    fill: "url(#paint108_linear_679_819)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M443.243 302.967C435.422 304.976 429.524 306.899 427.173 311.258C424.694 315.873 429.481 318.778 431.532 328.308C434.652 342.88 426.617 349.076 430.293 363.69C431.532 368.605 433.541 372.322 434.909 374.544C437.644 376.425 441.961 378.946 447.645 380.399C455.893 382.535 459.74 380.57 470.596 380.313C488.375 379.843 491.409 384.758 499.145 380.954C506.966 377.108 512.095 368.006 510.086 364.46C508.889 362.323 505.769 363.99 500.897 361.682C494.615 358.691 495.256 353.862 490.042 350.187C482.605 344.888 476.365 351.383 469.997 346.768C463.544 342.11 461.791 329.633 463.715 321.941C464.997 316.941 464.569 311.599 465.381 306.514C465.467 306.087 465.467 305.403 465.168 304.677C463.928 301.899 458.629 301.771 454.611 301.728C448.457 301.643 443.884 302.796 443.243 302.967Z",
    fill: "url(#paint109_linear_679_819)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M497.734 375.442C495.17 374.032 496.11 369.288 492.264 367.109C488.716 365.101 486.323 368.305 481.237 367.194C474.698 365.784 474.527 359.631 468.287 358.178C463.8 357.152 462.689 360.058 456.406 360.699C450.123 361.34 441.618 359.417 435.806 353.178C433.327 350.529 431.831 347.58 430.934 344.845C429.694 350.443 428.284 355.87 430.25 363.69C431.489 368.605 433.498 372.322 434.866 374.544C437.601 376.425 441.918 378.946 447.602 380.399C455.85 382.535 459.697 380.57 470.553 380.313C488.332 379.843 491.366 384.758 499.102 380.954C504.102 378.476 507.992 373.903 509.616 369.972C503.034 375.613 499.572 376.467 497.734 375.442Z",
    fill: "url(#paint110_linear_679_819)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M437.516 289.635C437.516 289.635 435.678 293.908 435.764 296.814C435.849 299.72 439.098 299.207 439.098 299.207L439.14 301.044C439.183 302.583 438.286 304.036 436.875 304.677L435.636 305.275C435.636 305.275 444.141 306.386 448.457 302.754H447.132C445.252 302.711 443.671 301.386 443.329 299.549L443.201 298.78C443.115 298.737 443.842 289.635 437.516 289.635Z",
    fill: "url(#paint111_linear_679_819)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M429.01 336.342L416.274 314.42C416.103 314.163 415.804 313.992 415.505 314.078L397.726 318.223C397.255 318.351 397.042 318.864 397.298 319.291L412.043 342.88C412.214 343.179 412.556 343.264 412.898 343.179L428.54 337.538L429.01 336.342Z",
    fill: "url(#paint112_linear_679_819)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M425.847 333.864L415.547 316.087C415.419 315.874 415.163 315.746 414.906 315.831L400.503 319.207C400.119 319.292 399.948 319.72 400.161 320.061L412.128 339.163C412.257 339.377 412.556 339.505 412.812 339.419L425.463 334.847L425.847 333.864Z",
    fill: "url(#paint113_linear_679_819)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M412.513 316.3L411.701 314.89C411.573 314.676 411.359 314.591 411.146 314.634L403.752 316.3C403.41 316.386 403.239 316.77 403.41 317.07L404.307 318.608C404.436 318.822 404.649 318.907 404.863 318.864L412.171 317.07C412.556 316.984 412.684 316.599 412.513 316.3Z",
    fill: "url(#paint114_linear_679_819)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M402.812 322.411C402.812 322.411 402.855 322.411 402.812 322.411L415.89 319.334C416.061 319.292 416.146 319.121 416.104 318.993C416.061 318.822 415.89 318.736 415.762 318.779L402.727 321.856C402.556 321.898 402.47 322.069 402.513 322.198C402.513 322.326 402.684 322.411 402.812 322.411Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M403.624 323.651C403.667 323.651 403.667 323.651 403.624 323.651L416.617 320.446C416.788 320.403 416.873 320.232 416.831 320.061C416.788 319.891 416.617 319.805 416.446 319.848L403.496 323.053C403.325 323.095 403.24 323.266 403.282 323.437C403.368 323.608 403.496 323.694 403.624 323.651Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M410.462 325.06H410.505L417.557 323.137C417.728 323.095 417.813 322.924 417.77 322.753C417.728 322.582 417.557 322.496 417.386 322.539L410.334 324.505C410.163 324.548 410.078 324.719 410.12 324.89C410.206 325.018 410.334 325.103 410.462 325.06Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M408.41 337.111C408.41 337.111 405.248 335.401 404.778 334.034C404.307 332.667 404.094 330.017 404.094 330.017L406.188 333.564C406.188 333.564 407 333.222 407.214 331.983C407.427 330.701 408.154 331.769 408.026 332.752C407.897 333.692 408.41 337.111 408.41 337.111Z",
    fill: "url(#paint115_linear_679_819)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M428.412 309.719C426.959 310.83 424.779 312.71 422.984 315.616C417.898 323.863 421.018 331.726 416.488 335.102C415.163 336.085 412.812 336.982 408.239 335.871L406.658 336.939C406.658 336.939 405.675 347.665 418.497 346.725C431.276 345.785 435.977 329.248 435.977 329.248L428.412 309.719Z",
    fill: "url(#paint116_linear_679_819)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M439.182 293.609C439.609 293.524 439.909 292.968 440.25 293.096C440.592 293.224 440.592 294.036 440.379 294.635C440.208 295.105 439.866 295.404 439.652 295.532C440.037 295.959 440.507 296.643 440.763 297.583C441.319 299.634 440.379 301.386 439.994 302.412C438.285 306.984 442.088 313.693 445.935 316.898C449.055 319.505 450.294 318.266 452.217 320.445C455.936 324.718 451.747 330.103 453.97 336.085C457.346 345.187 472.305 346.726 472.903 346.768C473.159 346.811 473.33 346.811 473.544 346.811C480.211 347.324 490.34 348.05 496.922 342.068C501.837 337.581 503.675 330.359 502.777 324.163C502.521 322.539 501.538 316.385 496.067 311.728C495.212 311.001 490.041 306.642 483.63 307.112C480.211 307.369 479.656 308.608 477.006 308.095C473.373 307.369 470.894 304.335 469.398 302.455C466.578 298.993 467.561 298.096 465.595 296.429C461.791 293.182 457.859 296.301 453.841 293.481C449.867 290.703 451.747 286.302 447.943 283.951C444.011 281.516 437.045 283.054 435.806 286.473C434.694 289.421 437.857 293.823 439.182 293.609Z",
    fill: "url(#paint117_linear_679_819)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_679_819",
    x1: 46.2104,
    y1: -2.14966,
    x2: 350.64,
    y2: 145.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99A70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_679_819",
    x1: 634.853,
    y1: 229.515,
    x2: 812.16,
    y2: 371.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#958FE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7373F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_679_819",
    x1: 44.0239,
    y1: 156.187,
    x2: 438.379,
    y2: 347.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99A70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_679_819",
    x1: 633.662,
    y1: 167.004,
    x2: 744.275,
    y2: 255.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#958FE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7373F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_679_819",
    x1: 529.81,
    y1: 54.9136,
    x2: 829.795,
    y2: 200.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#958FE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7373F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_679_819",
    x1: 338.345,
    y1: -23.2638,
    x2: 684.099,
    y2: 144.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99A70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_679_819",
    x1: 94.1057,
    y1: 83.1072,
    x2: 248.818,
    y2: 206.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#958FE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7373F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_679_819",
    x1: 392.163,
    y1: 90.9668,
    x2: 255.565,
    y2: 314.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#EBECF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_679_819",
    x1: 302.252,
    y1: 328.084,
    x2: 303.403,
    y2: 318.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#34264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56448C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_679_819",
    x1: 297.271,
    y1: 320.158,
    x2: 309.344,
    y2: 298.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#34264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56448C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_679_819",
    x1: 283.911,
    y1: 310.11,
    x2: 323.203,
    y2: 310.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#34264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56448C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_679_819",
    x1: 298.291,
    y1: 314.715,
    x2: 310.314,
    y2: 291.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#34264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56448C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_679_819",
    x1: 282.131,
    y1: 303.748,
    x2: 324.926,
    y2: 303.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#34264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56448C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_679_819",
    x1: 281.49,
    y1: 295.909,
    x2: 325.572,
    y2: 295.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#34264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56448C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_679_819",
    x1: 302.412,
    y1: 293.49,
    x2: 306.87,
    y2: 272.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#34264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56448C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_679_819",
    x1: 293.964,
    y1: 183.983,
    x2: 377.109,
    y2: 316.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0594089,
    stopColor: "#FEDB46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1473,
    stopColor: "#FFE344"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#FDDA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8144,
    stopColor: "#F9BD4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    stopColor: "#F8B84F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8B84F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_679_819",
    x1: 279.156,
    y1: 285.367,
    x2: 295.907,
    y2: 236.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#EBECF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_679_819",
    x1: 296.012,
    y1: 290.873,
    x2: 312.796,
    y2: 241.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#EBECF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_679_819",
    x1: 272.919,
    y1: 285.639,
    x2: 290.12,
    y2: 235.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#EBECF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_679_819",
    x1: 296.219,
    y1: 154.965,
    x2: 279.757,
    y2: 290.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0594089,
    stopColor: "#FEDB46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1473,
    stopColor: "#FFE344"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#FDDA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8144,
    stopColor: "#F9BD4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    stopColor: "#F8B84F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8B84F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_679_819",
    x1: 101.959,
    y1: 275.009,
    x2: 868.193,
    y2: 299.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99A70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_679_819",
    x1: 605.402,
    y1: 185.61,
    x2: 855.639,
    y2: 193.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99A70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_679_819",
    x1: 600.676,
    y1: 99.575,
    x2: 474.009,
    y2: 306.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#EBECF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_679_819",
    x1: 486.828,
    y1: 152.331,
    x2: 498.157,
    y2: 254.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_679_819",
    x1: 526.437,
    y1: 233.914,
    x2: 571.796,
    y2: 325.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#958FE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7373F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_679_819",
    x1: 460.232,
    y1: 197.081,
    x2: 520.981,
    y2: 275.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A81F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#425DCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_679_819",
    x1: 586.27,
    y1: 128.532,
    x2: 537.728,
    y2: 196.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99A70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_679_819",
    x1: 481.519,
    y1: 58.972,
    x2: 402.839,
    y2: 168.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99A70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_679_819",
    x1: 496.088,
    y1: 369.039,
    x2: 563.758,
    y2: 274.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99A70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_679_819",
    x1: 528.674,
    y1: 346.123,
    x2: 824.373,
    y2: 346.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_679_819",
    x1: 561.415,
    y1: 463.34,
    x2: 585.514,
    y2: 408.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A81F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#425DCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_679_819",
    x1: 619.38,
    y1: 431.991,
    x2: 828.087,
    y2: 431.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A81F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#425DCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_679_819",
    x1: 596.407,
    y1: 315.53,
    x2: 554.159,
    y2: 457.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_679_819",
    x1: 619.379,
    y1: 372.637,
    x2: 828.086,
    y2: 372.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_679_819",
    x1: 616.648,
    y1: 312.525,
    x2: 618.789,
    y2: 338.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44193E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_679_819",
    x1: 622.046,
    y1: 327.233,
    x2: 621.603,
    y2: 299.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_679_819",
    x1: 655.904,
    y1: 309.347,
    x2: 658.044,
    y2: 335.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44193E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_679_819",
    x1: 658.03,
    y1: 326.651,
    x2: 657.587,
    y2: 299.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_679_819",
    x1: 615.403,
    y1: 282.887,
    x2: 635.653,
    y2: 282.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56448C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#4F3E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_679_819",
    x1: 615.405,
    y1: 282.889,
    x2: 635.654,
    y2: 282.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56448C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#4F3E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_679_819",
    x1: 621.021,
    y1: 280.878,
    x2: 661.786,
    y2: 280.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56448C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#4F3E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_679_819",
    x1: 654.94,
    y1: 188.705,
    x2: 609.019,
    y2: 264.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A81F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#425DCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_679_819",
    x1: 645.619,
    y1: 187.744,
    x2: 641.295,
    y2: 225.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_679_819",
    x1: 646.793,
    y1: 196.642,
    x2: 640.693,
    y2: 178.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56448C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#4F3E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_679_819",
    x1: 641.725,
    y1: 183.352,
    x2: 645.123,
    y2: 211.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_679_819",
    x1: 592.153,
    y1: 227.652,
    x2: 624.948,
    y2: 227.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A81F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#425DCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_679_819",
    x1: 585.174,
    y1: 234.391,
    x2: 591.482,
    y2: 238.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_679_819",
    x1: 679.789,
    y1: 203.839,
    x2: 633.868,
    y2: 279.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A81F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#425DCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_679_819",
    x1: 613.005,
    y1: 238.053,
    x2: 680.288,
    y2: 238.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A81F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#425DCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_679_819",
    x1: 578.89,
    y1: 242.993,
    x2: 662.412,
    y2: 242.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56448C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#34264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_679_819",
    x1: 501.858,
    y1: 216.632,
    x2: 588.038,
    y2: 216.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56448C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#34264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_679_819",
    x1: 533.315,
    y1: 265.062,
    x2: 547.172,
    y2: 201.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56448C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#34264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_679_819",
    x1: 553.928,
    y1: 171.927,
    x2: 534.59,
    y2: 257.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56448C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#34264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_679_819",
    x1: 657.82,
    y1: 258.705,
    x2: 661.212,
    y2: 249.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_679_819",
    x1: 187.986,
    y1: 452.526,
    x2: 206.444,
    y2: 428.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#958FE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7373F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_679_819",
    x1: 229.317,
    y1: 411.155,
    x2: 203.406,
    y2: 342.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#958FE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7373F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_679_819",
    x1: 237.397,
    y1: 432.285,
    x2: 237.599,
    y2: 449.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#958FE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7373F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_679_819",
    x1: 304.859,
    y1: 496.999,
    x2: 290.27,
    y2: 496.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44193E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E3975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_679_819",
    x1: 294.807,
    y1: 496.17,
    x2: 282.736,
    y2: 459.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_679_819",
    x1: 277.712,
    y1: 503.163,
    x2: 263.123,
    y2: 503.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44193E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E3975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_679_819",
    x1: 267.66,
    y1: 502.335,
    x2: 255.588,
    y2: 466.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_679_819",
    x1: 233.775,
    y1: 442.215,
    x2: 284.671,
    y2: 447.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#34264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56448C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_679_819",
    x1: 227.174,
    y1: 455.987,
    x2: 262.971,
    y2: 459.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#34264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56448C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_679_819",
    x1: 261.8,
    y1: 378.443,
    x2: 280.57,
    y2: 430.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44193E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893947"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_679_819",
    x1: 252.722,
    y1: 349.158,
    x2: 232.672,
    y2: 406.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44193E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893947"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_679_819",
    x1: 222.266,
    y1: 416.101,
    x2: 246.427,
    y2: 385.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44193E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893947"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_679_819",
    x1: 229.541,
    y1: 369.876,
    x2: 242.925,
    y2: 342.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_679_819",
    x1: 228.803,
    y1: 360.848,
    x2: 241.481,
    y2: 343.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44193E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E3975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_679_819",
    x1: 239.036,
    y1: 348.471,
    x2: 233.298,
    y2: 376.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_679_819",
    x1: 231.009,
    y1: 361.989,
    x2: 243.232,
    y2: 345.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44193E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E3975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_679_819",
    x1: 241.521,
    y1: 352.325,
    x2: 240.162,
    y2: 355.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_679_819",
    x1: 229.773,
    y1: 341.17,
    x2: 209.724,
    y2: 398.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44193E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893947"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_679_819",
    x1: 274.972,
    y1: 423.336,
    x2: 276.069,
    y2: 418.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#34264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56448C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_679_819",
    x1: 248.935,
    y1: 410.558,
    x2: 306.231,
    y2: 410.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#34264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56448C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_679_819",
    x1: 305.35,
    y1: 389.108,
    x2: 299.591,
    y2: 375.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#34264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56448C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_679_819",
    x1: 257.826,
    y1: 382.298,
    x2: 348.693,
    y2: 382.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#34264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56448C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_679_819",
    x1: 257.826,
    y1: 398.654,
    x2: 340.052,
    y2: 398.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#34264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56448C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_679_819",
    x1: 292.726,
    y1: 414.088,
    x2: 297.846,
    y2: 416.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56448C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#34264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_679_819",
    x1: 284.178,
    y1: 414.981,
    x2: 303.03,
    y2: 414.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#34264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56448C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_679_819",
    x1: 299.75,
    y1: 400.222,
    x2: 323.285,
    y2: 400.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56448C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#34264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_679_819",
    x1: 300.781,
    y1: 400.216,
    x2: 324.3,
    y2: 400.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#34264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56448C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_679_819",
    x1: 228.767,
    y1: 413.095,
    x2: 245.647,
    y2: 413.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#34264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56448C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_679_819",
    x1: 232.919,
    y1: 407.723,
    x2: 236.168,
    y2: 418.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_679_819",
    x1: 751.696,
    y1: 237.59,
    x2: 842.56,
    y2: 299.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44193E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E3975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_679_819",
    x1: 739.473,
    y1: 275.479,
    x2: 762.936,
    y2: 339.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_679_819",
    x1: 713.469,
    y1: 384.807,
    x2: 724.566,
    y2: 377.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44193E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E3975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_679_819",
    x1: 717.11,
    y1: 387.768,
    x2: 738.897,
    y2: 322.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_679_819",
    x1: 713.456,
    y1: 357.75,
    x2: 720.941,
    y2: 357.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44193E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E3975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_679_819",
    x1: 709.117,
    y1: 378.299,
    x2: 721.336,
    y2: 341.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_679_819",
    x1: 724.179,
    y1: 316.536,
    x2: 733.292,
    y2: 369.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A81F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#425DCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_679_819",
    x1: 737.052,
    y1: 378.985,
    x2: 750.01,
    y2: 337.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A81F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#425DCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_679_819",
    x1: 737.051,
    y1: 378.985,
    x2: 750.01,
    y2: 337.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A81F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#425DCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_679_819",
    x1: 755.291,
    y1: 311.218,
    x2: 764.383,
    y2: 363.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A81F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#425DCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_679_819",
    x1: 758.676,
    y1: 268.485,
    x2: 782.138,
    y2: 332.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_679_819",
    x1: 769.766,
    y1: 276.887,
    x2: 764.44,
    y2: 252.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_679_819",
    x1: 766.155,
    y1: 255.348,
    x2: 772.259,
    y2: 286.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_679_819",
    x1: 744.467,
    y1: 309.526,
    x2: 793.618,
    y2: 309.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_679_819",
    x1: 739.718,
    y1: 310.531,
    x2: 775.027,
    y2: 310.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52407E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#4D3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_679_819",
    x1: 717.136,
    y1: 288.261,
    x2: 740.282,
    y2: 311.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52407E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#4D3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_679_819",
    x1: 717.137,
    y1: 288.261,
    x2: 740.283,
    y2: 311.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52407E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#4D3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_679_819",
    x1: 768.562,
    y1: 306.409,
    x2: 844.078,
    y2: 242.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_679_819",
    x1: 761.828,
    y1: 303.57,
    x2: 773.564,
    y2: 314.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_679_819",
    x1: 455.003,
    y1: 462.045,
    x2: 459.484,
    y2: 436.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56448C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#34264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_679_819",
    x1: 460.787,
    y1: 456.569,
    x2: 456.168,
    y2: 417.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_679_819",
    x1: 446.432,
    y1: 458.27,
    x2: 441.813,
    y2: 419.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_679_819",
    x1: 443.896,
    y1: 460.065,
    x2: 448.378,
    y2: 434.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56448C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#34264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_679_819",
    x1: 454.185,
    y1: 372.057,
    x2: 467.31,
    y2: 452.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44193E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893947"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_679_819",
    x1: 454.185,
    y1: 372.057,
    x2: 467.31,
    y2: 452.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44193E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893947"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_679_819",
    x1: 403.668,
    y1: 412.791,
    x2: 468.954,
    y2: 402.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44193E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893947"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_679_819",
    x1: 502.857,
    y1: 418.474,
    x2: 444.536,
    y2: 324.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99A70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_679_819",
    x1: 419.724,
    y1: 315.368,
    x2: 476.498,
    y2: 376.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99A70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_679_819",
    x1: 436.275,
    y1: 295.548,
    x2: 446.279,
    y2: 308.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_679_819",
    x1: 407.495,
    y1: 320.28,
    x2: 427.661,
    y2: 345.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56448C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#34264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_679_819",
    x1: 409.24,
    y1: 320.803,
    x2: 426.754,
    y2: 346.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_679_819",
    x1: 409.015,
    y1: 318.32,
    x2: 403.998,
    y2: 310.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A81F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#425DCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_679_819",
    x1: 405.197,
    y1: 331.522,
    x2: 410.036,
    y2: 337.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F39556"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_679_819",
    x1: 483.126,
    y1: 430.722,
    x2: 424.806,
    y2: 336.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99A70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_679_819",
    x1: 489.648,
    y1: 346.907,
    x2: 447.114,
    y2: 278.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56448C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#34264F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.75c41697ff16c24f9bf3087807f3b4e5.svg";
export { ForwardRef as ReactComponent };